import { motion } from "framer-motion";

interface Step {
  title: string;
  description: string;
}

interface SeoNumberedStepsProps {
  steps: Step[];
}

export const SeoNumberedSteps = ({ steps }: SeoNumberedStepsProps) => (
  <div className="space-y-4">
    {steps.map((step, i) => (
      <motion.div
        key={i}
        initial={{ opacity: 0, x: -10 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: i * 0.1 }}
        className="flex gap-4 items-start p-4 rounded-xl bg-muted/30 border border-border/50"
      >
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-brand-purple to-brand-magenta flex items-center justify-center shrink-0">
          <span className="text-white font-montserrat font-bold text-sm">{i + 1}</span>
        </div>
        <div>
          <h3 className="font-montserrat font-semibold text-primary text-sm mb-1">{step.title}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
        </div>
      </motion.div>
    ))}
  </div>
);
